var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from "classnames";
import { useField, useFormikContext } from "formik";
import React from "react";
export var FormItemBox = function (_a) {
    var name = _a.name, options = _a.options;
    var _b = useFormikContext(), submitForm = _b.submitForm, setFieldValue = _b.setFieldValue;
    var _c = __read(useField(name), 2), field = _c[0], meta = _c[1];
    var selectedValue = field.value;
    var handleChange = function (value) {
        setFieldValue(name, value);
        submitForm();
    };
    return (React.createElement("div", { className: "form-item-box" },
        React.createElement("div", { className: "form-item-box__items" }, options.map(function (_a) {
            var value = _a.value, name = _a.name, note = _a.note, tooltip = _a.tooltip;
            return (React.createElement("div", { key: value, className: classNames("form-item-box__item", {
                    "form-item-box__item--selected": value === selectedValue,
                }), onClick: function () { return handleChange(value); } },
                React.createElement("div", { className: "form-item-box__heading_box" },
                    React.createElement("div", { className: "form-item-box__heading" }, name),
                    tooltip ? (React.createElement("div", { className: "form-item-box__tooltip" },
                        "i",
                        React.createElement("div", { className: "form-item-box__tooltip_window tooltip" }, tooltip))) : (React.createElement(React.Fragment, null))),
                note && React.createElement("span", { className: "form-item-box__note" }, note),
                React.createElement("div", { className: "form-item-box__checkbox " })));
        }))));
};
